export default "__VITE_ASSET__C5wToa3k__"